import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import OutgoingSVG from '../assets/Outgoing.jsx';
import ProgressSVG from '../assets/InProgress.jsx'
import CompletedSVG from '../assets/Completed.jsx';
import { useAuth } from '../utils/AuthContext/AuthContext.jsx';
import InfoModal from './InfoModal.jsx';
import { useMediaQuery } from 'react-responsive';
import config from '../utils/config.js';
import LoadingSpinner from './LoadingSpinner/LoadingSpinner.jsx';
import { Link, useNavigate } from 'react-router-dom'; 

import ContractTimer from './ContractTimer.jsx';

// Redux Action
import { addPacketDetails, setPacketDetails } from '../redux/actions.js';

const ContractCard = ({ contractData }) => {
    const dispatch = useDispatch();
    const [etchPacketEid, setEtchPacketEid] = useState(null);
    const [loading, setLoading] = useState(true); 
    const packetDetails = useSelector((state) => etchPacketEid ? state.packet.packetDetails[etchPacketEid] : null);
    // const packetDetails = useSelector(state => state.packetDetails);
    const [showModal, setShowModal] = useState(false);
    const [isVoided, setIsVoided] = useState(false);
    const [voidResponse, setVoidResponse] = useState(null);
    const [isVoiding, setIsVoiding] = useState(false); // Add this state
    const [error, setError] = useState(null);
    const { token } = useAuth(); // Use user and token from context
    const confettiEmoji = "🎉 ";
    const navigate = useNavigate();
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });


    const handleCloseModal = () => {
        setShowModal(false); 
    }

    const navigateToContract = () => {
        navigate(`/contract/${contractData.formId}`);
    };

    const navigateToFormData = (e) => {
        e.stopPropagation();
        navigate(`/formdata/${contractData?.data?.formId || contractData?.formId}`, { state: {step: 2 } });
    };

    const fetchData = async () => {
            setLoading(true); // Set loading to true at the beginning
            fetch(`${config.apiBaseUrl}/formdata/${contractData?.formId}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
            .then(response => response.json())
            .then(data => {
                dispatch(addPacketDetails(contractData.formId, {...data}));
                setEtchPacketEid(contractData.formId);
                setLoading(false); 
            })
            .catch(error => console.error('Error:', error));
    }

    useEffect(() => {
        fetchData();

        const intervalId = setInterval(fetchData, 900000); 

        return () => clearInterval(intervalId); 
    }, [contractData.formId, token]);

// VOID SECTION

const handleVoidClick = () => {
    
    if (!packetDetails?.packetDetails?.documentGroup?.eid || isVoided || isVoiding) {
        return; // Prevent multiple voids
    }

    const eid = packetDetails?.packetDetails?.documentGroup?.eid;
        fetch(`${config.apiBaseUrl}/void/${eid}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ voidedReason: 'User is voiding contract' }),
    })
    .then(response => {
        setVoidResponse(response.ok); // Set the void response
        if (response.ok) {
            // Show success message
            alert('Contract voided successfully');
            setVoidResponse(true); // Set void response to true
            setIsVoided(true);
        } else {
            // Show error message
            alert('Failed to void contract');
            setVoidResponse(false);
        }
        return response.json();
    })
    .then(data => {
        setShowModal(false);
        if (voidResponse) {
        }

        // Moved fetch request here
        const etchPacketEid = packetDetails?.etchPacketEid;
        const formId = packetDetails?.formId; 

        fetch(`${config.apiBaseUrl}/packet/${etchPacketEid}`)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                dispatch(setPacketDetails(etchPacketEid, data.data.etchPacket));

                    return fetch(`${config.apiBaseUrl}/formdata/${formId}`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        etchPacketEid: etchPacketEid,
                        packetDetails: data.data.etchPacket,
                    }),
                })
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    return response.json();
                })
                .then(data => {

                    dispatch(setPacketDetails(etchPacketEid, data.packetDetails));
                })
                .catch(error => {
                    console.error('Error during fetch:', error);
                });
            })
            .catch(error => {
                console.error('Error during fetch:', error);
            });
    })
    .catch(error => {
        alert('Failed to void contract');
    });
};
 
if (loading) {
    return null;
}

    return (
        <div>
            <button onClick={navigateToContract} className="w-[275px] md:w-[360px] h-48 md:h-64 justify-start items-start flex-col relative">
                {loading ? (
                    <img className="w-[275px] md:w-[360px] h-24 md:h-32 rounded-tl-[10px] rounded-tr-[10px]" src="https://images.pexels.com/photos/106399/pexels-photo-106399.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2" alt="Placeholder" />
                ) : (
                    <img className="w-[275px] md:w-[360px] h-24 md:h-32 rounded-tr-[10px] rounded-tl-[10px]" src={packetDetails?.data?.streetViewUrl} alt="Street View" />
                )}
                  
                <div className="w-[275px] md:w-[360px] h-28 md:h-32 pl-4 pr-4 py-2 bg-white rounded-bl-[10px] rounded-br-[10px] shadow flex-col">                    
                    <div className="w-[250px] md:w-[320px] mb-3 md:mb-4 justify-between items-center inline-flex">
                        <div className='inline-flex gap-2 items-center'>
                            {
                            packetDetails?.packetDetails?.documentGroup?.status === 'partial' && (
                                isMobile ? <OutgoingSVG width="20px" height="20px"/> : <OutgoingSVG width="25px" height="25px"/>
                            )
                            }

                            {
                            packetDetails?.packetDetails?.documentGroup?.status === 'completed' && (
                                isMobile ? <CompletedSVG width="20px" height="20px"/> : <CompletedSVG width="25px" height="25px"/>
                            )
                            }
                            <span className="text-center text-black w-auto flex-shrink-0 text-[12px] md:text-sm font-['Inter']">{new Date(contractData.updatedAt).toLocaleDateString()}</span>
                        </div>
                        <div className={`h-6 p-2.5 w-auto rounded-[10px] items-center flex flex-shrink-0 ${packetDetails?.packetDetails?.documentGroup?.status === 'partial' && !isVoided ? "bg-blue-100" : packetDetails?.packetDetails?.documentGroup?.status === 'completed' ? "bg-green-200" : packetDetails?.packetDetails?.documentGroup?.status === 'terminated' ? 'bg-red-200' : packetDetails?.packetDetails && packetDetails?.packetDetails?.documentGroup === null ? "bg-red-200" : "bg-gray-200"} `}>
                            <span className={`text-[13px] md:text-[15px] font-light font-['Inter'] flex-shrink-0 ${packetDetails?.packetDetails?.documentGroup?.status === 'partial' && !isVoided ? "text-blue-700" : packetDetails?.packetDetails?.documentGroup?.status === 'completed' ? "text-green-700" : packetDetails?.packetDetails && (packetDetails?.packetDetails?.documentGroup === null || packetDetails?.packetDetails?.documentGroup?.status === 'terminated') ? 'text-red-700' : "text-gray-700"}`}>
                                {packetDetails?.packetDetails?.documentGroup?.status === 'completed' && confettiEmoji}
                                
                                {packetDetails?.packetDetails?.documentGroup?.status === 'partial' && !isVoided ? "Partially Signed" : packetDetails?.packetDetails?.documentGroup?.status === 'completed' ? confettiEmoji && "Signed" : packetDetails?.packetDetails?.documentGroup?.status === 'terminated' ? "Terminated" : packetDetails?.packetDetails && packetDetails?.packetDetails?.documentGroup === null ? "Voided" : "Incomplete"}
                            </span>
                        </div>
                    </div>

                <div className="w-[275px] md:w-[320px] mb-3 md:mb-4 items-center align-middle gap-4 md:gap-10 md:justify-between flex">
                        <div className="text-[14px] md:text-[17px] text-center w-auto text-black font-medium font-['Inter']">${contractData?.data?.prices?.[0]?.purchasePrice}</div>
                        <span className="text-center w-[160px] md:w-[205px] text-neutral-500 text-[14px] overflow-ellipsis overflow-hidden whitespace-nowrap font-medium font-['Inter']">{(Object.values(contractData.data?.address).join(', '))}</span>
                    </div>
                    <div className='inline-flex justify-between items-center w-full'>
                        <div className='inline-flex w-auto gap-2'>
                            {(packetDetails?.packetDetails?.status !== 'completed' || isVoided) && (
                                <div
                                    className="text-center z-10 font-medium font-['Inter']"
                                    onClick={navigateToFormData}
                                >
                                    <div 
                                        className="w-full text-sm md:text-[14px] z-10 h-7 md:h-8 px-4 py-1 bg-white rounded-[10px] border text-shi-green border-green-900 justify-center items-center gap-1.5 md:gap-2.5 flex hover:bg-slate-300 hover:text-green-900">
                                        {packetDetails?.packetDetails && packetDetails?.packetDetails?.documentGroup === null ? 'Edit & Resend' : 'Edit'}
                                    </div>
                                </div>
                            )}
                            {(packetDetails?.packetDetails && (packetDetails?.packetDetails?.status !== 'completed' && packetDetails?.packetDetails?.status !== 'draft') && !isVoided) ? (
                                <div className="text-center z-10 font-medium font-['Inter']">
                                    <div 
                                        className="w-full text-sm md:text-[14px] z-10 h-7 md:h-8 px-4 py-1 bg-white rounded-[10px] border text-black border-slate-900 justify-center items-center gap-1.5 md:gap-2.5 flex hover:bg-slate-300"
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            setShowModal(true);
                                        }}
                                    >Void</div>
                                    {<InfoModal />}
                                </div>
                            ) : ( '' )}
                        </div>
                            <ContractTimer   
                                packetDetails={packetDetails}
                                contractData={contractData} 
                                onContractExpire={() => {
                                    if (!isVoided) {
                                        handleVoidClick();
                                    }
                                }}  
                            />

                    </div>
                </div>
                <InfoModal isOpen={showModal} onClose={handleCloseModal}>
                    <div>
                        <p>Are you sure you want to void this contract?</p>
                        <div className='w-full mt-3 inline-flex gap-20 justify-center items-center'>
                            <button 
                                className='border border-red-600 rounded-md p-1.5 w-[80px] hover:bg-slate-200' 
                                onClick={(event) => {
                                    event.stopPropagation(); 
                                    handleVoidClick(packetDetails?.packetDetails?.documentGroup?.eid); 
                                    setShowModal(false); 
                                    }}
                                >Yes</button>
                            <button 
                                className='border border-black rounded-md p-1.5 w-[80px] hover:bg-slate-200' 
                                onClick={(event) => {
                                    event.stopPropagation();
                                    setShowModal(false);
                                }}
                            >No</button>
                        </div>
                    </div>
                </InfoModal>
            </button>
        </div>
    )
}
export default ContractCard; 